import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import { msalInstance } from './auth-config';
import { EventType } from '@azure/msal-browser';
// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    //@ts-ignore account object will be there if the login is success
    event.payload.account
  ) {
    //@ts-ignore account object  will be there if the login is success
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const container = document.getElementById('app');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App instance={msalInstance} />
  </React.StrictMode>
);
